import { Suspense, lazy } from 'react';
import { Navigate, useRoutes, useLocation } from 'react-router-dom';
import LoginLayout from '../layouts/LoginLayout';
import LogoOnlyLayout from '../layouts/LogoOnlyLayout';
import PedidosLayout from '../layouts/pedidos/PedidosLayout'
import ChatLayout from '../layouts/pedidos/ChatLayout'
import DetalhesLayout from '../layouts/pedidos/DetalhesLayout'
import AvaliacaoLayout from '../layouts/AvaliacaoLayout';
import GuestGuard from '../guards/GuestGuard';
import AuthGuard from '../guards/AuthGuard';
import PedidoIdGuard from '../guards/PedidoIdGuard';
import InsuranceGuard from '../guards/InsuranceGuard';
import LoadingScreen from '../components/LoadingScreen';
import TokenLayout from '../layouts/TokenLayout';


const Loadable = (Component) => (props) => {
  const { pathname } = useLocation();
  const isDashboard = pathname.includes('/dashboard');

  return (
    <Suspense
      fallback={
        <LoadingScreen
          sx={{
            ...(!isDashboard && {
              top: 0,
              left: 0,
              width: 1,
              zIndex: 9999,
              position: 'fixed'
            })
          }}
        />
      }
    >
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {
  return useRoutes([
    {
      path: '*',
      element: <LogoOnlyLayout />,
      children: [
        {
          path: '404',
          element: <NotFound />
        },
        {
          path: '*',
          element: <Navigate to="/404" replace />
        }
      ]
    },
    {
      path: '/',
      element: <LoginLayout />,
      children: [
        {
          path: '/',
          element: <GuestGuard>
            <Autenticacao />
          </GuestGuard>
        },
      ]
    },
    {
      path: '/pedidos',
      element:
        <AuthGuard>
          <PedidosLayout />
        </AuthGuard>,
      children: [
        {
          path: '/pedidos',
          element: <Pedidos />
        },
      ]
    },
    {
      path: '/chat',
      element: <PedidoIdGuard>
        <ChatLayout />
      </PedidoIdGuard>,
      children: [
        {
          path: '/chat',
          element: <Chat />
        },
      ]
    },
    {
      path: '/detalhes',
      element: <PedidoIdGuard>
        <DetalhesLayout />
      </PedidoIdGuard>,
      children: [
        {
          path: '/detalhes',
          element: <Detalhes />
        },
        {
          path: '/detalhes/documentos',
          element: <Documentos />
        },
      ]
    },
    {
      path: '/insurance',
      children: [
        {
          path: '/insurance/details/:id',
          element: <InsuranceDetails />
        },
        {
          path: '/insurance/check1/:id',
          element: <InsuranceForm1 />
        },
        {
          path: '/insurance/check2',
          element: <InsuranceGuard>
            <InsuranceForm2 />
          </InsuranceGuard>
        },
        {
          path: '/insurance/confirm',
          element: <InsuranceGuard>
            <InsuranceConfirm />
          </InsuranceGuard>
        },
      ]
    },
    {
      path: '/agendamento',
      element:
        <PedidoIdGuard>
          <Agendamento />
        </PedidoIdGuard>,
    },
    {
      path: '/avaliacao',
      element: <AvaliacaoLayout />,
      children: [
        { path: '/avaliacao', element: <Avaliacao /> },
      ]
    },
    {
      path: '/token',
      element: <TokenLayout />,
      children: [
        {
          path: '/token',
          element: <AutenticacaoToken />
        },
      ]
    },
    { path: '*', element: <Navigate to="/404" replace /> }
  ]);
}

const NotFound = Loadable(lazy(() => import('../pages/Page404')));
const Autenticacao = Loadable(lazy(() => import('../pages/autenticacao/pages/Autenticacao')));
const AutenticacaoToken = Loadable(lazy(() => import('../pages/autenticacao/pages/AutenticacaoToken')));
const Pedidos = Loadable(lazy(() => import('../pages/pedidos/Pedidos')));
const Chat = Loadable(lazy(() => import('../pages/pedidos/Chat')));
const Detalhes = Loadable(lazy(() => import('../pages/pedidos/Detalhes')));
const Documentos = Loadable(lazy(() => import('../pages/pedidos/Documentos')));
const Agendamento = Loadable(lazy(() => import('../pages/agendamento/Agendamento')));
const Avaliacao = Loadable(lazy(() => import('../pages/avaliacao/avaliacao')));
const InsuranceDetails = Loadable(lazy(() => import('../pages/insurance/pages/InsuranceDetails')));
const InsuranceForm1 = Loadable(lazy(() => import('../pages/insurance/pages/InsuranceForm1')));
const InsuranceForm2 = Loadable(lazy(() => import('../pages/insurance/pages/InsuranceForm2')));
const InsuranceConfirm = Loadable(lazy(() => import('../pages/insurance/pages/InsuranceConfirm')));